// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2vGBu","buttons":"RemoveExpirationActionButtons_buttons__2TbmZ"};